<template>
	<div>
		<el-popover v-if="dropdown" placement="bottom" :title="title" trigger="click">
			<button
				slot="reference"
				class="menu-item"
				:class="{ 'is-active': isActive ? isActive() : null }"
				:style="{ display: isVisible() ? 'block' : 'none' }"
				:title="title"
			>
				<svg class="remix">
					<use :xlink:href="require('remixicon/fonts/remixicon.symbol.svg') + `#ri-${icon}`" />
				</svg>
			</button>
			<div v-if="is_procedural">
				<el-input-number @change="action(srcSize + 'px')" v-model="srcSize"> </el-input-number>
				<div
					class="infinite-list"
					v-infinite-scroll="load"
					style="overflow: auto; max-height: 200px; display: flex; flex-direction: column"
				>
					<el-button
						style="margin-left: 0px"
						round
						v-for="i in count"
						v-if='i>=10 && i%2===0'
						@click="action(i + 'px')"
						class="infinite-list-item"
						>{{ i }}px
					</el-button>
				</div>
			</div>
			<div v-else style="display: flex; flex-direction: column">
				<el-button style="margin-left: 0px" v-for="el in dropdown" round @click="el.action">
					{{ el.title }}</el-button
				>
			</div>
		</el-popover>
		<button
			v-else-if="!subelements"
			class="menu-item"
			:class="{ 'is-active': isActive ? isActive() : null }"
			:style="{ display: isVisible() ? 'block' : 'none' }"
			@click="action"
			:title="title"
		>
			<svg class="remix" :style="[color ? { fill: color } : {}]">
				<use :xlink:href="require('remixicon/fonts/remixicon.symbol.svg') + `#ri-${icon}`" />
			</svg>
		</button>
		<el-popover v-else placement="bottom" :title="title" trigger="click">
			<button
				slot="reference"
				class="menu-item"
				:class="{ 'is-active': isActive ? isActive() : null }"
				:style="{ display: isVisible() ? 'block' : 'none' }"
				:title="title"
			>
				<svg class="remix">
					<use :xlink:href="require('remixicon/fonts/remixicon.symbol.svg') + `#ri-${icon}`" />
				</svg>
			</button>
			<div style="display: inline-flex">
				<div v-for="(item, index) in subelements">
					<div class="divider" v-if="item.type === 'divider'" :key="index" />
					<menu-item v-else :key="index" v-bind="item" />
				</div>
			</div>
		</el-popover>
	</div>
</template>
<script>
import MenuItem from "./MenuItem.vue"

export default {
	name: "menu-item",
	components: {
		MenuItem
	},
	data() {
		return {
			select: undefined,
			count: 50,
			srcSize: ""
		}
	},
	methods: {
		load() {
			this.count += 2
		}
	},
	props: {
		icon: {
			type: String,
			required: false
		},
		color: {
			type: String,
			required: false
		},
		title: {
			type: String,
			required: false
		},
		action: {
			type: Function,
			required: false
		},
		isActive: {
			type: Function,
			default: null
		},
		isVisible: {
			type: Function,
			default: null
		},
		subelements: {
			type: Array,
			required: false
		},
		dropdown: {
			required: false
		},
		is_procedural: {
			type: Boolean,
			required: false
		}
	}
}
</script>
<style lang="scss" scoped>
.menu-item {
	width: 1.75rem;
	height: 1.75rem;
	color: #0d0d0d;
	border: none;
	background-color: transparent;
	border-radius: 0.4rem;
	padding: 0.25rem;
	margin-right: 0.25rem;

	svg {
		width: 100%;
		height: 100%;
		fill: currentColor;
	}

	&.is-active,
	&:hover {
		color: #fff;
		background-color: #0d0d0d;
	}
}
</style>
<style lang="scss" scoped>
.divider {
	width: 2px;
	height: 1.25rem;
	background-color: rgba(0, 0, 0, 0.1);
	margin-left: 0.5rem;
	margin-right: 0.75rem;
}
</style>
